import { set } from "ramda";
import {
    SET_SELECTED_BRANCH,
    SET_SELECTED_REQUEST_TYPE,
    SET_TRANSFER_ORDER_DETAILS,
    SET_TRANSFER_ORDER_NUMBER,
    ORDER_CREATION_SUCCESS,
    SET_IS_EDIT_ORDER,
    SET_IDISPOSITION,
    SET_TRANSFER_REQUEST_DATA,
    SET_ASSET_DATA,
    SET_REACTIVATION_REQUEST_DATA,
    SET_CART_IDISPOSITION,
    SET_ASSET_CART_DATA,
    SET_IS_RESET_CLICKED,
    SET_IS_LAST_REQUEST_DELETED,
    SET_IS_CART_NOT_UPDATED,
    SET_ALL_CART_ASSET,
    SET_IS_SAVE_AS_DRAFT,
    SET_IS_CHANGES_OCCURED_IN_CART,
    SET_IS_COSTCENTER_AVAILABLE_FOR_SUBMIT,
    SET_AFE_RECLASSIFICATION_DATA,
    GET_LEADR_ORDER_VALIDATION,
    SET_LEADR_ORDER_VALIDATION,
    SET_AFE_ASSET_DETAIL_DATA,
    SET_AFE_BRANCH_ADDRESS_DETAIL,
    SET_VALIDATE_AFE_ASSET_NUMBER,
    GET_VALIDATE_AFE_ASSET_NUMBER,
    GET_SAVE_AFE_RECLASSIFICATION,
    SET_SAVE_AFE_RECLASSIFICATION,
    SET_AFE_ORDER_BY_ID,
    GET_AFE_ORDER_BY_ID,
    GET_VALIDATE_ASSETS_ON_SAVE,
    SET_VALIDATE_ASSETS_ON_SAVE
} from "./TransferType";


const setSelectedBranch = (selectedBranch: any) => ({
    type: SET_SELECTED_BRANCH,
    selectedBranch: selectedBranch
});

const setSelectedRequestType = (selectedRequestType: any) => ({
    type: SET_SELECTED_REQUEST_TYPE,
    selectedRequestType: selectedRequestType
});

const setTransferOrderDetails = (order: any) => ({
    type: SET_TRANSFER_ORDER_DETAILS,
    order: order
});

const setTransferOrderNumber = (number: any) => ({
    type: SET_TRANSFER_ORDER_NUMBER,
    number
})

const setOrderCreationSuccess = (flag: any) => ({
    type: ORDER_CREATION_SUCCESS,
    flag
})

const setIsEditOrder = (flag: any) => ({
    type: SET_IS_EDIT_ORDER,
    flag
})

const setIDisposition = (dispositionData: any) => ({
    type: SET_IDISPOSITION,
    dispositionData
})

const setCartIDisposition = (dispositionData: any) => ({
    type: SET_CART_IDISPOSITION,
    dispositionData
})

const setTransferRequestData = (requests: any) => ({
    type: SET_TRANSFER_REQUEST_DATA,
    requests
});

const setAssetData = (assets: any) => ({
    type: SET_ASSET_DATA,
    assets
});

const setAssetCartData = (assets: any) => ({
    type: SET_ASSET_CART_DATA,
    assets
});

const setReactivationRequestData = (requests: any) => ({
    type: SET_REACTIVATION_REQUEST_DATA,
    requests
});

const setIsResetClicked = (flag: any) => ({
    type: SET_IS_RESET_CLICKED,
    flag
});

const setIsLastRequestDeleted = (flag: any) => ({
    type: SET_IS_LAST_REQUEST_DELETED,
    flag
});

const setIsCartNotUpdated = (flag: any) => ({
    type: SET_IS_CART_NOT_UPDATED,
    flag
});

const setAllCartAsset = (allCartAsset: any) => ({
    type: SET_ALL_CART_ASSET,
    allCartAsset: allCartAsset
});

const setIsSaveAsDraft = (isSaveAsDraft: any) => ({
    type: SET_IS_SAVE_AS_DRAFT,
    isSaveAsDraft: isSaveAsDraft
});

const setIsChangesOccuredInCart = (isChangesOccuredInCart ?: any) => ({
    type: SET_IS_CHANGES_OCCURED_IN_CART,
    isChangesOccuredInCart: isChangesOccuredInCart
}) 

const setIsCostCenterAvailableForSubmit = (isCostCenterAvailableForSubmit: any) => ({
    type: SET_IS_COSTCENTER_AVAILABLE_FOR_SUBMIT,
    isCostCenterAvailableForSubmit: isCostCenterAvailableForSubmit
})

const setAfeReClassificationData = (afeReClassificationData: any) => ({
    type: SET_AFE_RECLASSIFICATION_DATA,
    afeReClassificationData: afeReClassificationData
})

const getLeadOrderValidation = (orderNumber: any) => ({
    type: GET_LEADR_ORDER_VALIDATION,
    orderNumber
})

const setLeadOrderValidation = (leadrOrderValidation: any) => ({
    type: SET_LEADR_ORDER_VALIDATION,
    leadrOrderValidation: leadrOrderValidation
})

const setAfeAssetDetailData = (afeAssetDetailData: any) => ({
    type: SET_AFE_ASSET_DETAIL_DATA,
    afeAssetDetailData: afeAssetDetailData
});

const setAfeBranchAddressDetail = (afeBranchAddressDetail: any) => ({
    type: SET_AFE_BRANCH_ADDRESS_DETAIL,
    afeBranchAddressDetail: afeBranchAddressDetail
});

const getAFEAssetValidation = (val: any) => ({
    type: GET_VALIDATE_AFE_ASSET_NUMBER,
    val
})

const setAFEAssetValidation = (afeAssetValidation: any) => ({
    type: SET_VALIDATE_AFE_ASSET_NUMBER,
    afeAssetValidation: afeAssetValidation
})

const getSaveAfeReClassification = (val?: any) => ({
    type: GET_SAVE_AFE_RECLASSIFICATION,
    val
})

const setSaveAfeReClassification = (saveAfeReclassification: any) => ({
    type: SET_SAVE_AFE_RECLASSIFICATION,
    saveAfeReclassification: saveAfeReclassification
})

const getAfeOrderById = (val: any) => ({
    type: GET_AFE_ORDER_BY_ID,
    val
})

const setAfeOrderByIdData = (afeOrderByIdData: any) => ({
    type: SET_AFE_ORDER_BY_ID,
    afeOrderByIdData: afeOrderByIdData
})

const getValidateAssetsOnSave = (val: any) => ({
    type: GET_VALIDATE_ASSETS_ON_SAVE,
    val
})

const setValidateAssetsOnSave = (validateAssetsOnSaveResult: any) => ({
    type: SET_VALIDATE_ASSETS_ON_SAVE,
    validateAssetsOnSaveResult
})

export default {
    setAllCartAsset,
    setSelectedBranch,
    setSelectedRequestType,
    setTransferOrderDetails,
    setTransferOrderNumber,
    setOrderCreationSuccess,
    setIsEditOrder,
    setIDisposition,
    setCartIDisposition,
    setTransferRequestData,
    setAssetData,
    setAssetCartData,
    setReactivationRequestData,
    setIsResetClicked,
    setIsLastRequestDeleted,
    setIsCartNotUpdated,
    setIsSaveAsDraft,
    setIsChangesOccuredInCart,
    setIsCostCenterAvailableForSubmit,
    setAfeReClassificationData,
    getLeadOrderValidation,
    setLeadOrderValidation,
    setAfeAssetDetailData,
    setAfeBranchAddressDetail,
    getAFEAssetValidation,
    setAFEAssetValidation,
    getSaveAfeReClassification,
    setSaveAfeReClassification,
    getAfeOrderById,
    setAfeOrderByIdData,
    getValidateAssetsOnSave,
    setValidateAssetsOnSave
};
